<template>
    <div class="btn-group">
        <icon-button
            v-for="({ id, icon }, index) in config"
            :key="index"
            :active="isButtonActive(id)"
            :icon="icon"
            :is-button-group="true"
            @click="onChange(id)"
            class="navigation-button"
        >
            <span class="btn-text">
                {{ capitalize(id) }}
            </span>
        </icon-button>
    </div>
</template>

<script>
import IconButton from './iconButton/IconButton';

function isConfigValid(value) {
    return Array.isArray(value) && value.every(v => v.hasOwnProperty('id') && v.hasOwnProperty('icon'));
}

export default {
    name: 'ButtonGroupNavigation',
    components: { IconButton },
    props: {
        config: {
            type: Array,
            required: true,
            validator(value) {
                return isConfigValid(value);
            }
        },
        selectedId: {
            type: String,
            required: true
        }
    },
    methods: {
        onChange(id) {
            this.$emit('change', id);
        },
        isButtonActive(id) {
            return this.selectedId === id;
        },
        capitalize(text) {
            return text.charAt(0).toUpperCase() + text.slice(1);
        }
    }
};
</script>

<style lang="scss">
@import '../../src/assets/styles/settings';

.navigation-button {
    outline: none;

    &:not(:first-child):not(:last-child) {
        border-radius: 0;
    }

    &:first-child {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
    }

    &:last-child {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
    }
}

@media (max-width: $screen-lg) {
    .btn-text {
        display: none;
    }
}
</style>
